/**
 * 是否嵌套在甜瓜 tgFrame iframe 内。
 * 跨域时读取 window.top.document 会抛 SecurityError，需优先用 URL 参数判断。
 */
export function isInTGFrame() {
  if (typeof window === 'undefined') return false

  try {
    const params = new URLSearchParams(window.location.search || '')
    // tgFrame 历史拼写 fromeTheme，同时兼容 fromTheme
    if (params.get('fromTheme') === 'tgFrame' || params.get('fromeTheme') === 'tgFrame') {
      return true
    }
  } catch (e) {
    // ignore
  }

  try {
    return !!(
      window.top &&
      window.top.document &&
      String(window.top.document.title || '').includes('甜瓜iframe')
    )
  } catch (e) {
    // 跨域无法读取 top.document
    return false
  }
}

/**
 * 在 tgFrame 内时跳顶层，否则当前页跳转
 */
export function navigateTGFrameOrSelf(url) {
  if (!url) return
  if (isInTGFrame()) {
    try {
      window.top.location.replace(url)
      return
    } catch (e) {
      // fall through
    }
  }
  window.location.href = url
}
